import SunglassesIcon from "../images/sunglasses.jpg";
import JeansIcon from "../images/jeans.jpg";
import NikeIcon from "../images/nike.jpg";
import Scarves from "../images/scarves.jpg";
import BlueBag from "../images/blueBag.jpg";
import BagIcon from "../images/bag.jpg";
import Addidas from "../images/addidas.jpg";
import Shirt from "../images/shirt.jpg";

export const DataProduct = [
  {
    id: 0,
    name: "Vuitton Sunglasses",
    picture: SunglassesIcon,
    price: 1107,
  },
  {
    id: 1,
    name: "Hourglass Jeans",
    picture: JeansIcon,
    price: 1567,
  },
  {
    id: 2,
    name: "Nike Sport Shoe",
    picture: NikeIcon,
    price: 1234,
  },
  {
    id: 3,
    name: "Hermes Silk Scarves",
    picture: Scarves,
    price: 2312,
  },
  {
    id: 4,
    name: "Succi Ladies Bag",
    picture: BlueBag,
    price: 1456,
  },
  {
    id: 5,
    name: "Gucci Womens's Bags",
    picture: BagIcon,
    price: 2345,
  },
  {
    id: 6,
    name: "Addidas Running Shoe",
    picture: Addidas,
    price: 2345,
  },

  {
    id: 7,
    name: "Bilack Wear's Shirt",
    picture: Shirt,
    price: 1245,
  },
];
